import React from 'react';
import { Redirect, Route } from 'react-router-dom';

// export const PrivateRoute = ({ component: Component, ...rest }) => (
//   <Route
//     {...rest}
//     render={(props) =>
//       sessionStorage.getItem('login') ? (
//         <Component {...props} />
//       ) : (
//         <Redirect
//           to={{
//             pathname: '/login',
//             state: { from: props.location },
//           }}
//         />
//       )
//     }
//   />
// );
export const PrivateRoute = ({ children, ...rest }) => (
   <Route
      {...rest}
      render={(props) =>
         sessionStorage.getItem('login') ? (
            children
         ) : (
            <Redirect
               to={{
                  pathname: '/login',
                  state: { from: props.location },
               }}
            />
         )
      }
   />
);
